module.exports = __webpack_public_path__ + "static/media/eyeAlt.8fc512b7.svg";